// Which API paths are about a person's ACCOUNT rather than about this installation.
//
// Kept in its own file, with no imports, because the rule is worth being able to run on its own. The
// distinction it draws is not cosmetic: an account is one Cognito account shared by every deployment,
// while permissions and preferences belong to whichever installation you are looking at. Send one to
// the wrong place and it appears to save and then quietly does nothing.

// Exact paths only. /v1/access is deliberately absent — who may see which chamber is stored by the
// installation that holds the chamber, and must never be written to another one.
export const IDENTITY_PATHS = [
  '/v1/users',
  '/v1/usergroups',
  '/v1/user-usergroups',
  '/v1/userstatus',
];

const EXACT = new Set(IDENTITY_PATHS);

// Matched exactly, NEVER by prefix.
//
// `/v1/users/self`, `/v1/users/alert-limits` and `/v1/users/signature` all begin with `/v1/users`,
// and all three are per-installation: the first is how someone edits their own alert preferences on
// the box they are looking at. A `startsWith` here would send those to the cloud, where they would
// succeed against a different copy of that person — so the setting saves, returns 200, and has no
// effect on the box. That is the whole reason this is a Set of exact strings and not a prefix test.
//
// Anything unrecognised stays local, which is the safe direction: an endpoint added later goes to
// this installation rather than silently to someone else's.
export const isIdentityPath = (url) => {
  if (typeof url !== 'string') return false;
  const path = url.split('?')[0].split('#')[0].replace(/\/+$/, '');
  return EXACT.has(path);
};
